import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskServiceDetailsRoute: InvariantJiraRoute = {
	name: 'servicedesk-service-details',
	path: '/jira/servicedesk/projects/:projectKey/services/:serviceAri',
};
